"use client";

import React, { useState } from "react";
import { Card, Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tab, Tabs, Chip } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

const ChatbotHealthCard = ({ data = {} }) => {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Card
            sx={{
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                borderRadius: "12px",
                p: 0,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                border: "1px solid #e0e0e0",
                overflow: "hidden"
            }}
        >
            <Box sx={{ p: 3, pb: 0 }}>
                <Typography variant="h6" fontWeight={700} sx={{ fontSize: "1.1rem" }}>
                    Chatbot User Interface
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 2 }}>
                    Overview of system stability and user feedback
                </Typography>

                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    aria-label="health tabs"
                    textColor="primary"
                    indicatorColor="primary"
                    sx={{
                        minHeight: '40px',
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '0.9rem',
                            minHeight: '40px',
                            mr: 2
                        }
                    }}
                >
                    <Tab
                        label="Complaints Registered"
                        sx={{ pl: 0 }}
                    />
                    <Tab
                        label="Errors Reported"
                    />
                </Tabs>
            </Box>

            <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
                {tabValue === 1 && (
                    <TableContainer>
                        <Table size="small" aria-label="errors table">
                            <TableHead>
                                <TableRow sx={{ bgcolor: "#F9FAFB" }}>
                                    <TableCell sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.75rem', py: 1.5, pl: 3 }}>DETAIL</TableCell>
                                    <TableCell sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.75rem', py: 1.5 }}>MODULE</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.75rem', py: 1.5, pr: 3 }}>TIME</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.top_errors?.map((row, index) => (
                                    <TableRow key={index} hover>
                                        <TableCell component="th" scope="row" sx={{ fontSize: '0.85rem', color: '#101828', py: 1.5, pl: 3, fontWeight: 500 }}>
                                            {row.detail}
                                        </TableCell>
                                        <TableCell sx={{ py: 1.5 }}>
                                            <Chip
                                                label={row.module}
                                                size="small"
                                                sx={{
                                                    bgcolor: '#FEF3F2',
                                                    color: '#B42318',
                                                    borderRadius: '16px',
                                                    height: '22px',
                                                    fontSize: '0.75rem',
                                                    fontWeight: 500
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell align="right" sx={{ fontSize: '0.85rem', color: '#667085', py: 1.5, pr: 3 }}>
                                            {row.datetime}
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {(!data.top_errors || data.top_errors.length === 0) && (
                                    <TableRow>
                                        <TableCell colSpan={3} align="center" sx={{ color: 'text.secondary', py: 4 }}>
                                            No errors reported
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}

                {tabValue === 0 && (
                    <TableContainer>
                        <Table size="small" aria-label="reports table">
                            <TableHead>
                                <TableRow sx={{ bgcolor: "#F9FAFB" }}>
                                    <TableCell sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.75rem', py: 1.5, pl: 3 }}>DETAIL</TableCell>
                                    <TableCell sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.75rem', py: 1.5 }}>TYPE</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.75rem', py: 1.5, pr: 3 }}>TIME</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.top_reports?.map((row, index) => (
                                    <TableRow key={index} hover>
                                        <TableCell component="th" scope="row" sx={{ fontSize: '0.85rem', color: '#101828', py: 1.5, pl: 3, fontWeight: 500 }}>
                                            {row.detail}
                                        </TableCell>
                                        <TableCell sx={{ py: 1.5 }}>
                                            <Chip
                                                label={row.type}
                                                size="small"
                                                sx={{
                                                    bgcolor: row.type === 'Client' ? '#EFF8FF' : '#FFF9F5',
                                                    color: row.type === 'Client' ? '#175CD3' : '#C4320A',
                                                    borderRadius: '16px',
                                                    height: '22px',
                                                    fontSize: '0.75rem',
                                                    fontWeight: 500
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell align="right" sx={{ fontSize: '0.85rem', color: '#667085', py: 1.5, pr: 3 }}>
                                            {row.datetime}
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {(!data.top_reports || data.top_reports.length === 0) && (
                                    <TableRow>
                                        <TableCell colSpan={3} align="center" sx={{ color: 'text.secondary', py: 4 }}>
                                            No complaints registered
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Box>
        </Card>
    );
};

export default ChatbotHealthCard;
